import {cx} from "emotion";
import * as React from "react";

import "./calendar.scss";

import {getMonthWeeks, parseDate, sameDate} from "../../utils/date-object";
import {FComponent} from "../../react/f-component";
import {monthLabelsFull} from "../../utils/date/month-labels-full";

interface S {
    day: number;
    month: number;
    year : number;
}
interface P {
    className: string;
    selectedDate;
    onChange;
    close;
}

export class Calendar extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            day: props.selectedDate ? props.selectedDate.day : new Date().getDay(),
            month: props.selectedDate ? props.selectedDate.month : new Date().getMonth() + 1,
            year : props.selectedDate ? props.selectedDate.year  : new Date().getFullYear(),
        };
    }

    render() {
       
        const {month, year, day} = this.state;
        const {className, onChange, close} = this.props;
        let years = [];
        let min = new Date().getFullYear() - 100;
        let max = new Date().getFullYear() + 50;
        for(let i = min; i<=max; i++){
            years.push(i);
        }

        const renderWeek = (weekDays) => (
            <div
                className="date-row"
                key={`${weekDays[0].month}-${weekDays[0].day}`}
            >
                {weekDays.map((wd) => (
                    <div
                        key={wd.day}
                        className={cx("day", {
                            today: sameDate(wd, parseDate(new Date())),
                            "other-month": wd.month !== month,
                            selected: day && month && year && wd.month === month && sameDate(wd, {day, month, year}),
                        })}
                        onMouseDown={() => {
                            if (wd.month === month) {
                                this.setState({day: wd.day, month: wd.month, year: wd.year})
                            } else {
                                this.setState({month: wd.month, year: wd.year});
                            }
                        }}
                    >
                        <label>{wd.day}</label>
                    </div>
                ))}
            </div>
        );

        return (
            <div className={cx(className, "calendar-j4938")}>
                <div className="header-controls">

                    <button
                        className="btn-nav-style btn-left"
                        onMouseDown={(e) => {
                            if (month === 1) {
                                this.setState({
                                    month: 12,
                                    year: year - 1,
                                })
                            } else {
                                this.setState({month: month - 1});
                            }
                            e.preventDefault();
                        }}
                        xd-qa-type="button"
                        xd-qa-name={monthLabelsFull[month-1] + " " + year}
                    >
                        <i className="fa fa-caret-left"/>
                    </button>

                    {monthLabelsFull[month-1]}
                    {" "}
                    {year}

                    <button
                        className="btn-nav-style btn-right"
                        onMouseDown={(e) => {
                            if (month === 12) {
                                this.setState({
                                    month: 1,
                                    year: year + 1,
                                })
                            } else {
                                this.setState({month: month + 1})
                            }
                            e.preventDefault();
                        }}
                        xd-qa-type="button"
                        xd-qa-name="right"
                    >
                        <i className="fa fa-caret-right"/>
                    </button>

                </div>
                <div className="header-controls">
                        <select
                            className="select-month"
                            value={month-1}
                            onChange={(e) => {
                                this.setState({month: parseInt(e.target.value, 10) + 1});
                                e.preventDefault();
                            }}
                            xd-qa-type="dropdown"
                        >
                            {monthLabelsFull.map((month, index)=>(
                                <option value={index}>{month}</option>
                            ))}
                        </select>
                        <select
                            className="select-year"
                            value={year}
                            onChange={(e) => {
                                this.setState({year: parseInt(e.target.value, 10)});
                                e.preventDefault();
                            }}
                            xd-qa-type="dropdown"
                        >
                            {years.map((year)=>(
                                <option>{year}</option>
                            ))}
                        </select>
                </div>
                <div className="date-picker-panel">
                    <div className="header-row">
                        {weekDays.map((wd) => (
                            <div className="day" key={wd}>
                                <label>
                                    {wd}
                                </label>
                            </div>
                        ))}
                    </div>

                    {getMonthWeeks({month, year}).map((weekDays) => (
                        renderWeek(weekDays)
                    ))}

                </div>
                <div className="header-controls">
                    <button
                        className="btn-footer-style"
                        xd-qa-type="button"
                        xd-qa-name="Cancel"
                        onClick={()=> {return close();} }
                    >
                        Cancel
                    </button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button
                        className="btn-footer-style"
                        onClick={()=> {return onChange(this.state);} }
                        xd-qa-type="button"
                        xd-qa-name="Save"
                    >
                        Save
                        </button>
                </div>
            </div>
        );
    }
}

const weekDays = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
];

const fillRange = (start, end) => {
    return Array(end - start + 1).fill(0).map((item, index) => start + index);
};

